import styled from 'styled-components';

export const SPreloader = styled.div`
  display: flex;
  background: #000000;
  position: fixed;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 200%;
  z-index: 1000;
  pointer-events: all;
`;

export const SLogo = styled.div`
  position: fixed;
  top: 50%;
  flex: 0 0 100%;
  width: 100%;
  max-width: 60vw;
  animation: fadeIn 0.5s forwards;
  transform: translateY(-50%);

  @media (orientation: portrait) {
    max-width: 80vw;
  }
`;

export const SImage = styled.img`
  width: 100%;
`;

export const SProgressBar = styled.div`
  position: relative;
  width: 70%;
  height: 14px;
  margin: 20px auto auto;
  background: #232222;
  border-radius: 10px;
  overflow: hidden;
`;

export const SProgressTrack = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  background-color: #16307c;
  background-image: linear-gradient(90deg, #16307c, #28bcea);
  border-radius: 10px;
  height: 100%;
`;
